var map = {
	"./alfa romeo.svg": "18f9",
	"./audi.svg": "1807",
	"./bmw.svg": "6334",
	"./byd.svg": "fde2",
	"./citroen.svg": "7c3e",
	"./cupra.svg": "c6e1",
	"./dacia.svg": "76a8",
	"./ds.svg": "e45c0",
	"./fiat.svg": "536b",
	"./ford.svg": "e306",
	"./honda.svg": "d90d",
	"./hyundai.svg": "1440",
	"./jaguar.svg": "b35f",
	"./jeep.svg": "0b57",
	"./kia.svg": "e6d2",
	"./maxus.svg": "431f",
	"./mazda.svg": "2f27",
	"./mercedes-benz.svg": "2961",
	"./mg.svg": "1e68",
	"./mini.svg": "2ba5",
	"./nissan.svg": "eb8c",
	"./opel.svg": "464c",
	"./peugeot.svg": "ca56",
	"./polestar.svg": "3dd0",
	"./porsche.svg": "3d9b",
	"./renault.svg": "c266",
	"./seat.svg": "ac79",
	"./skoda.svg": "9773",
	"./smart.svg": "3c2d",
	"./tesla.svg": "7ec4",
	"./volvo.svg": "e0dd",
	"./vw.svg": "efd0",
	"./zhidou.svg": "40b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0c66";